import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Device, DeviceId, DeviceType } from '@shared/models/device';
import { BacnetPointSelectionCallback, BacnetPoint, ModbusPointSelectionCallback, LoRaWANPointSelectionCallback } from '@shared/models/point';
import { ModbusPoint } from '@shared/models/modbus';
import { LoRaWANDevicePoint, lorawanDevicePointToPointID } from '@shared/models/lorawan';
import { TileType } from '@shared/models/tile';
import { BacnetPointDiscoveryComponent } from '@lib/components/bacnet-point-discovery/bacnet-point-discovery.component';
import { ModbusPointEditorComponent } from '@lib/components/modbus-point-editor/modbus-point-editor.component';
import { LoRaWANPointsComponent } from '@lib/components/lorawan-points/lorawan-points.component';
import { PointSelection } from '../shared/models/tile-data-source.model';

export { PointSelection };

@Component({
  selector: 'motn-device-point-selector',
  templateUrl: './device-point-selector.component.html',
  styleUrls: ['./device-point-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BacnetPointDiscoveryComponent, ModbusPointEditorComponent, LoRaWANPointsComponent],
})
export class DevicePointSelectorComponent {
  @Input() device!: Device;
  @Output() pointSelected$ = new EventEmitter<PointSelection>();
  @Output() closed$ = new EventEmitter<void>();

  readonly DeviceType = DeviceType;

  readonly bacnetCallback: BacnetPointSelectionCallback = (p: BacnetPoint, _d: Device) => {
    this.pointSelected$.emit({
      pointId: p.ID ?? JSON.stringify([p.Type, p.Address]),
      pointName: p.Name || p.Description || p.Address,
    });
  };

  readonly modbusCallback: ModbusPointSelectionCallback = (p: ModbusPoint, _tt: TileType, _d: DeviceId) => {
    this.pointSelected$.emit({
      pointId: p.ID,
      pointName: p.Name,
    });
  };

  readonly lorawanCallback: LoRaWANPointSelectionCallback = (p: LoRaWANDevicePoint) => {
    this.pointSelected$.emit({
      pointId: lorawanDevicePointToPointID(p),
      pointName: p.ID[1],
    });
  };
}
